var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'shotcode' + (this.size ? ' shotcode--' + _vm.size : '')},[_c('svg',{ref:"svg",staticClass:"shotcode__svg",attrs:{"viewBox":"0 0 100 100"}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90daf294","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Shotcode.vue
// module id = hE9p
// module chunks = 0